module.exports = __webpack_public_path__ + "static/media/Group129.850849bb.png";